import axios from "axios";
import { convertUrl } from "../helpers/helper";

const state = {
  applications: [],
  applicationsList: [],
  paginationPages: 1,
  paginationCurrentPage: 1,
  validationErrors: [],
  isLoading: false,
};

const mutations = {
  SET_APPLICATIONS(state, data) {
    state.applications = data;
  },
  SET_APPLICATIONS_LIST(state, data) {
    state.applicationsList = data;
  },

  SET_PAGINATION_PAGES(state, data) {
    state.paginationPages = data;
  },

  SET_PAGINATION_CURRENT_PAGE(state, data) {
    state.paginationCurrentPage = data;
  },

  SET_VALIDATION_ERRORS(state, data) {
    state.validationErrors = data;
  },

  SET_IS_LOADING(state, data) {
    state.isLoading = data;
  },
};

const actions = {
  async getApplications({ commit }, payload) {
    commit("SET_APPLICATIONS", []);
    commit("SET_IS_LOADING", true);
    try {
      let apiUrl = convertUrl("application", payload);
      let { data } = await axios.get(apiUrl);
      if (Array.isArray(data)) {
        commit("SET_APPLICATIONS", data);
      } else {
        commit("SET_APPLICATIONS", data?.result);
        commit("SET_PAGINATION_PAGES", data?.pages);
      }
    } catch (error) {
      commit("SET_APPLICATIONS", []);
    }
    commit("SET_IS_LOADING", false);
  },

  async getApplicationsList({ commit }) {
    try {
      let { data } = await axios.get("application");
      if (Array.isArray(data)) {
        commit("SET_APPLICATIONS_LIST", data);
      }
    } catch (error) {
      commit("SET_APPLICATIONS_LIST", []);
    }
  },

  async saveApplication({ dispatch, commit }, payload) {
    try {
      await axios.post("application", payload);
      dispatch("getApplications", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async updateApplication({ dispatch, commit }, payload) {
    try {
      await axios.put(`application/${payload.id}`, payload);
      dispatch("getApplications", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async deleteApplication({ dispatch }, id) {
    try {
      await axios.delete(`application/${id}`);
      dispatch("getApplications", { page: 1 });
    } catch (error) {
      throw new Error("No se pudo realizar está operación");
    }
  },

  cleanValidationErrors({ commit }) {
    commit("SET_VALIDATION_ERRORS", []);
  },

  updateCurrentPage({ commit }, page) {
    commit("SET_PAGINATION_CURRENT_PAGE", page);
  },

  cleanApplicationsList({ commit }) {
    commit("SET_APPLICATIONS_LIST", []);
  },
};

const getters = {
  getApplications(state) {
    return state.applications;
  },
  getApplicationsList(state) {
    return state.applicationsList;
  },

  getPaginationPages(state) {
    return state.paginationPages;
  },

  getValidationErrors(state) {
    return state.validationErrors;
  },
};

const application = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default application;
